import React from "react";

import Banner from "../components/Banner";

function About() {
  return (
    <>
      <Banner title="About" subtitle="" />

      <section className="py-4" id="Vision">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p
                className="fs-5 fw-bolder text-start mb-2"
                style={{ color: "#1155cc" }}
              >
                A National Vision Built by the People
              </p>

              <p className="fs-5 text-muted mb-4">
                SEA’s 2050 was established to provide Sierra Leone with a clear,
                shared, and sustainable development pathway toward 2050. The
                initiative is grounded in the belief that national development
                must be people-centered, forward-looking, and environmentally
                responsible.
              </p>

              <p className="fs-5 text-muted mb-4">
                By applying Strategic Environmental Assessment at a national
                scale, SEA’s 2050 evaluates development choices before they are
                made helping decision-makers balance growth, equity, and
                environmental protection.
              </p>

              <p className="fs-5 text-muted mb-4">
                The initiative is open, transparent, and participatory, enabling
                citizens, institutions, civil society, the private sector, and
                development partners to contribute meaningfully to national
                planning.
              </p>
            </div>
          </div>

          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <button
              className="btn btn-primary btn-lg px-4"
              onClick={() => (window.location.href = "/who-should-participate")}
            >
              Read More
            </button>
          </div>
        </div>
      </section>

      {/* Website Disclosure / Privacy Notice */}
      <section className="py-5" id="privacy-notice">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p
                className="fs-5 fw-bolder text-start mb-3"
                style={{ color: "#1155cc" }}
              >
                How we use AI to process project data
              </p>

              <p className="fs-5 text-muted mb-4">
                As part of SEAs2050, E&amp;S Solutions uses AI systems to
                transcribe, organise, and analyse voice recordings and written
                materials collected during project activities (such as
                meetings, consultations, and participant submissions).
              </p>

              <p className="fs-5 fw-bold mb-2">
                What this involves:
              </p>

              <ul className="fs-5 text-muted mb-4">
                <li className="mb-2">
                  Voice recordings may be processed using AI speech-to-text
                  tools to create transcripts.
                </li>
                <li className="mb-2">
                  Written submissions and documents may be analysed using AI
                  tools to support project reporting and analysis.
                </li>
                <li className="mb-2">
                  This processing is for internal project purposes only. It is{" "}
                  <strong>not used to train or improve any AI model</strong>{" "}
                  unless you have been separately and specifically asked for
                  consent to do so.
                </li>
                <li className="mb-2">
                  This processing does not involve identifying individuals by
                  their voice — recordings are used to generate text
                  transcripts only.
                </li>
              </ul>

              <p className="fs-5 fw-bold mb-2">
                Where your data is processed:
              </p>

              <p className="fs-5 text-muted mb-4">
                Processing takes place using Amazon Web Services (AWS)
                infrastructure located in the United States. Because this
                involves transferring personal data outside the EU/EEA, we rely
                on the EU-US Data Privacy Framework as our legal transfer
                mechanism.
              </p>

              <p className="fs-5 text-muted mb-4">
                For general information about how we handle personal data as a
                company, including your rights and our list of service
                providers, see our{" "}
                <a
                  href="https://www.essolutions.ai/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </p>

              <p className="fs-5 fw-bold mb-2">
                Your rights:
              </p>

              <p className="fs-5 text-muted mb-2">
                You have the right to:
              </p>

              <ul className="fs-5 text-muted mb-4">
                <li className="mb-2">
                  Ask what data we hold about you and how it's being used.
                </li>
                <li className="mb-2">
                  Object to this processing at any time, without needing to
                  give a reason.
                </li>
                <li className="mb-2">
                  Ask us to delete your data, where applicable.
                </li>
                <li className="mb-2">
                  Withdraw any consent you've given, at any time, as easily as
                  you gave it.
                </li>
              </ul>

              <p className="fs-5 text-muted mb-4">
                To exercise any of these rights, contact us at{" "}
                <a href="mailto:info@essolutions.ai">
                  info@essolutions.ai
                </a>
                . We'll respond within 30 days, in line with our standard
                privacy policy commitment.
              </p>

              <p className="fs-5 fw-bold mb-2">
                Data retention:
              </p>

              <p className="fs-5 text-muted mb-4">
                We keep this data for the duration of the project plus 36
                months for reporting purposes, after which it is deleted unless
                you've asked us to do so sooner.
              </p>

              <p className="fs-6 text-muted mb-3">
                <em>Last updated: September 2026</em>
              </p>

              <p className="fs-5 text-muted mb-0">
                For the full E&amp;S Solutions privacy policy, please visit{" "}
                <a
                  href="https://essolutions.ai/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  essolutions.ai/privacy-policy
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;